import React, { Component, Fragment } from "react";
import {Modal, ModalBody, Button, ModalHeader } from "reactstrap";
import AdminCursoFormCerrado from "./AdminCursoFormCerrado";

class AdminCursoModalCerrado extends Component {


    state = {
        modal: false
      };

    toggle = () => {
    this.setState(previous => ({
        modal: !previous.modal
    }));
    };  

    render() {
        const create = this.props.create;
        const proyectoCode = this.props.proyectoCodeSelected;
        const proyectoName = this.props.proyectoNameSelected;
        const proyectoMoneda = this.props.proyectoMoneda || 'USD';
        const admin = this.props.admin;
        const partners = this.props.partners;
        const estudiantesIngreso = this.props.estudiantesIngreso;

        var title = "Editando Admininstrador del Curso";
        var button = <Button onClick={this.toggle}>
        Editar
        </Button>;

        if (create) {
            title = "Aggregando Adminstrador del Curso ";

            button = (
            <Button
                color="primary"
                className="float-end"
                onClick={this.toggle}
                style={{ minWidth: "200px" }}
            >
                Agregar Adminstrador de Curso
            </Button>
            );
        }

    return (
      <Fragment>
        {button}
        <Modal isOpen={this.state.modal} toggle={this.toggle} unmountOnClose>
        <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
          <ModalBody>
            <AdminCursoFormCerrado
              resetState={this.props.resetState}
              toggle={this.toggle}
              proyectoCode= {proyectoCode}
              proyectoName = {proyectoName}
              proyectoMoneda={proyectoMoneda}
              partners={partners}
              estudiantesIngreso = {estudiantesIngreso}
              admin = {admin}
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default AdminCursoModalCerrado;